import { ITimeModel, Time } from './Time';

class TimeRange {
  public readonly duration: Time;

  private constructor(
    public readonly from: Time,
    public readonly to: Time,
  ) {
    if (from > to) {
      throw Error('from cannot be greater than to in a TimeRange');
    }
    const durationMs = this.to.toMilliseconds() - this.from.toMilliseconds();
    this.duration = Time.fromMilliseconds(durationMs);
  }

  public includes(time: Time) {
    return time >= this.from && time <= this.to;
  }

  public static fromObject([from, to]: [Partial<ITimeModel>, Partial<ITimeModel>]): TimeRange {
    return new TimeRange(Time.fromObject(from), Time.fromObject(to));
  }

  public toString(precision: 'hour' | 'minute' | 'second' = 'second') {
    return `${this.from.toString(precision)} - ${this.to.toString(precision)}`;
  }

  public copy() {
    return TimeRange.fromObject([this.from.copy(), this.to.copy()]);
  }
}

export default TimeRange;
